<template>
    <div id="article-details" @click="testClick">
      <div class="article-details-title" v-model="article">
        <h1>{{article.title}}</h1>
      </div>
      <div class="article-details-pic">
        <img v-bind:src="article.cover"/>
      </div>
      <div class="article-details-content">
        <!--<p v-html="article.content">直接插入型</p>-->
        <inner-content-component :con="article.content"></inner-content-component>
      </div>
    </div>
</template>

<script>
    import {articleDetails} from "../../api/api";

    export default {
      name: "ArticleDetails",
      props: {
        id: 0
      },
      data: function () {
        return {
          article: {
            title: "",
            //cover: "./../../../static/pic/article-details.jpg",
            content: ""
          },
          articleId: this.id
        }
      },
      created() {
        this.getArticleDetails(this.id);
      },
      updated() {
      },
      watch: {
        id: function (newVal, oldVal) {
          debugger;
        }
      },
      methods: {
        getArticleDetails: function (id) {
          const res = articleDetails({
            id: id
          });
          debugger;
          res.then(x => {
            console.log("getArticleDetails:",x);
            this.article = x.data.data;
          })
        },
        testClick: function () {
          console.log("testClick:", this.id, "-",this.articleId);
          debugger;
        }
      },
      components: {
        //内部嵌套型
        innerContentComponent:{
          props: {
            con: ""
          },
          data: function(){
            return{
              count: 0
            }
          },
          template:"<div v-html='con'></div>",
          methods:{
          },
        }
      }
    }
</script>

<style scoped>
  div, img, p {
    margin: 0;padding: 0;border: 0;
  }
  #article-details .article-details-title{
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100px;
    line-height: 2.5em;
    font-size: 1.25em;
    border-style: solid;
    border-color: #797979;
    border-width: 0;
  }
  #article-details .article-details-pic {
    position: relative;
    display: inline-block;
    width: 900px;
    height: 300px;
    padding: 2px;
    border-width: 2px;
    border-style: dotted;
    animation: border-color-move 5s infinite linear;
  }
  #article-details .article-details-pic img{
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  #article-details .article-details-content {
    position: relative;
    display: inline-block;
    margin: 20px;
    padding: 20px;
    width: 90%;
    line-height: 2.5em;
    font-size: 1.25em;
    text-align: left;
    border-style: solid;
    border-color: #797979;
    border-width: 0;
  }
  /*规定动画*/
  @keyframes border-color-move {
    from {
      /*给图像应用色相旋转*/
      border-color: red;
    }
    to {
      border-color: blue;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/articles/ArticleDetails.vue